import { render, staticRenderFns } from "./GymContact.vue?vue&type=template&id=7c04cfe8"
import script from "./GymContact.vue?vue&type=script&lang=js"
export * from "./GymContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports